var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"content-wrap pb-4",class:_vm.$vuetify.breakpoint.smAndDown ? 'pa-0 ma-0' : null,attrs:{"fluid":""}},[_c('top'),_c('youtube')],1),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }